import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useGetCurrentUserQuery } from 'services';

import { useForeignAuthorProcess } from './useForeignAuthorProcess';

/**
 * @description Yazar adına işlem yapılan ekranların (statü 22 madde gönderimi, statü 54 tercüme
 * gönderimi) route koruması. Bu ekranların route'ları herkese açık kayıtlıdır (`situation: ['all']`),
 * bu yüzden yetkiyi sayfanın kendisi kontrol eder: madde yabancı yazar sürecinde değilse ya da
 * kullanıcı sorumlu ilim heyetinin başkanı/sekreteri değilse madde detayına yönlendirilir.
 *
 * Yönlendirme, madde ve current_user yüklenmeden yapılmaz — aksi halde veri gelene kadar yetkili
 * kullanıcı da dışarı atılırdı. `replace` kullanılır ki geri tuşu ekrana geri dönmesin.
 *
 * Yetki kuralı burada yeniden hesaplanmaz, `useForeignAuthorProcess`'ten okunur; bayrak ayrıca geri
 * döndürülür ki çağıran ekran uyarı basmak için ikinci bir kaynağa gitmesin.
 *
 * @param {Object|null} offer Madde teklifi (`ArticleOffer`); `id` alanı yönlendirme adresini kurar.
 * @param {Object} [options]
 * @param {boolean} [options.isLoading=false] Madde sorgusu hâlâ sürüyor mu.
 * @param {boolean} [options.enabled=true] Koruma etkin mi. Aynı ekran hem yazarın kendi gönderimi hem
 *   de yazar adına gönderim için kullanılıyorsa yalnız ikinci modda açılır.
 * @returns {boolean} Kullanıcı bu maddede yazar adına işlem yapabiliyor mu.
 */
export const useForeignAuthorScreenGuard = (offer, { isLoading = false, enabled = true } = {}) => {
  const navigate = useNavigate();
  const { data: current_user } = useGetCurrentUserQuery();
  const { canActAsAuthor } = useForeignAuthorProcess(offer);

  useEffect(() => {
    if (enabled && !isLoading && offer && current_user && !canActAsAuthor) {
      navigate(`/madde-detay/${offer.id}`, { replace: true });
    }
  }, [enabled, isLoading, offer, current_user, canActAsAuthor, navigate]);

  return canActAsAuthor;
};
